import React, { useState } from "react";
import { DPButton, DPDialog } from "Components/DP";
import { CreateManagerStepper } from "./CreateManagerStepper/CreateManagerStepper";
import useStyles from "./styles";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";

export const CreateOperatingManager = () => {
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyles();

  const onAddButtonClick = () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.AddOperatingManagerClicked,
    });
    setIsOpen(true);
  };

  return (
    <>
      <DPButton onClick={onAddButtonClick} className={classes.button}>
        Add Operating Manager
      </DPButton>
      <DPDialog open={isOpen}>
        <CreateManagerStepper closeModal={() => setIsOpen(false)} />
      </DPDialog>
    </>
  );
};
